import React from 'react'
import ReactDatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'


const DatePicker = ({ onChange, name, object, onBlur, readOnly, minDate = moment(), maxDate = null,
                    placeholder = '', dateFormat = 'DD.MM.YYYY', showTimeSelect = false,
                    onKeyDown = null,
}) => {
    const value = object[name] ? moment(object[name]) : null

    return (
        <div style={{ width: '100%' }}>
            <ReactDatePicker
                selected={value}
                className="form-control"
                readOnly={readOnly}
                minDate={minDate}
                maxDate={maxDate}
                disabled={readOnly}
                showTimeSelect={showTimeSelect}
                dateFormat={dateFormat}
                placeholderText={placeholder}
                onChange={(date) => {
                    const value = date ? date.format('YYYY-MM-DDTHH:mm:ss') : null
                    onChange(name, value)
                    onBlur()
                }}
                onKeyDown={onKeyDown}
            />
        </div>
    )
}

DatePicker.propType = {}

export default DatePicker



// WEBPACK FOOTER //
// ./src/modules/form/component/DatePicker.js